// client/src/pages/ownerListings/ListingMessagesPage.js — the renter's / buyer's side of a
// masked conversation about a listing, by the private link in our email. Nobody's email
// address or phone number is shown to the other side.
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

const ListingMessagesPage = () => {
    const { token } = useParams();
    const [t, setT] = useState(null);
    const [err, setErr] = useState('');
    const [body, setBody] = useState('');
    const [hp, setHp] = useState('');
    const base = `/api/public/owner-listings/messages/${encodeURIComponent(token)}`;
    const load = useCallback(() => fetch(base).then(async (r) => { const j = await r.json(); if (!r.ok) throw new Error(j.message); setT(j); }).catch((e) => setErr(e.message)), [base]);
    useEffect(() => { load(); }, [load]);
    const send = async (e) => {
        e.preventDefault(); setErr('');
        const r = await fetch(base, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body, website: hp }) });
        const j = await r.json().catch(() => ({}));
        if (!r.ok) { setErr(j.message || 'Could not send.'); return; }
        setBody(''); load();
    };
    return (
        <div className="flex min-h-screen justify-center bg-slate-100 p-4">
            <main className="w-full max-w-xl rounded-lg bg-white p-6 shadow">
                <h1 className="text-xl font-bold text-slate-900">{t && t.title_line ? `About ${t.title_line}` : 'Your conversation'}</h1>
                {err && <p className="mt-3 text-red-700" role="alert">{err}</p>}
                {t && <>
                    <ul className="mt-4 space-y-2" aria-live="polite">
                        {t.messages.map((m, i) => (
                            <li key={i} className={`rounded p-3 text-sm ${m.sender === 'you' ? 'bg-indigo-50' : 'bg-slate-50'}`}>
                                <span className="font-semibold">{m.sender === 'you' ? 'You' : m.sender === 'owner' ? 'Owner' : 'Our office'}</span>
                                <span className="ml-2 text-xs text-slate-500">{new Date(m.created_at).toLocaleString('en-US')}</span>
                                <p className="whitespace-pre-line">{m.body}</p>
                            </li>))}
                    </ul>
                    <form onSubmit={send} className="mt-4">
                        <label htmlFor="lm-body" className="block text-sm font-medium text-slate-800">Reply</label>
                        <textarea id="lm-body" rows={3} className="mt-1 block w-full rounded-md border border-slate-400 px-3 py-2" value={body} onChange={(e) => setBody(e.target.value)} />
                        <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px' }}><label htmlFor="lm-website">Website</label><input id="lm-website" tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} /></div>
                        <button type="submit" disabled={!body.trim()} className="mt-2 rounded-md bg-slate-900 px-4 py-2 font-semibold text-white disabled:opacity-60">Send</button>
                        <p className="mt-2 text-xs text-slate-600">Your email address is not shown to the owner. A licensee from our brokerage can read this conversation.</p>
                    </form>
                </>}
                <p className="mt-6 text-sm"><Link to="/properties" className="text-indigo-800 underline">Search properties</Link></p>
            </main>
        </div>
    );
};
export default ListingMessagesPage;
